var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.15 39.55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#333530;stroke-miterlimit:10;stroke-width:1.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,19.29h0c-2.35,0-7.62,1-8.37,3.63-.35,1.19-1.76,9.26-1.76,9.26H22.1s-1.41-8.07-1.76-9.26C19.58,20.3,14.3,19.29,12,19.29Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "17.46 32.18 17.5 24.82 6.45 24.82 6.48 32.18 17.46 32.18"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    y1: 32.18,
    x2: 28.54,
    y2: 32.18
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M35,10.08a3.76,3.76,0,0,1-3.68-3.94V4.82a3.69,3.69,0,1,1,7.36,0V6.14A3.76,3.76,0,0,1,35,10.08Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M30.39,39.55V19.29s-3,1.84-3.69,1.84A7.83,7.83,0,0,1,23,19.29a26.86,26.86,0,0,1-2.19-1.9,1.32,1.32,0,0,1,1.39-2.19l3.56,1.33c1.38-1.44,2.82-3.68,6.45-3.68h6.44c3.3,0,4.61,1.39,4.61,5.52v5.52c0,2-.79,2.77-2.77,2.77h-.92"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 34.99,
    y1: 26.66,
    x2: 34.99,
    y2: 39.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 39.59,
    y1: 18.37,
    x2: 39.59,
    y2: 39.55
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,16.53a3.77,3.77,0,0,1-3.68-4V11.27A3.77,3.77,0,0,1,12,7.32a3.77,3.77,0,0,1,3.68,3.95v1.31A3.77,3.77,0,0,1,12,16.53Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassroom);
export default __webpack_public_path__ + "static/media/classroom.e4ad6a2d6f8cd6681a9079447fad946f.svg";
export { ForwardRef as ReactComponent };